import React, { useState, useEffect } from 'react';
import { getContracts } from '@/lib/api';
import { FileText, Loader2, Calendar, Clock } from 'lucide-react';

export default function MyContract() {
  const [contracts, setContracts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getContracts().then(setContracts).catch(console.error).finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="flex items-center justify-center py-20"><Loader2 className="w-6 h-6 text-[#3A4035] animate-spin" /></div>;

  const contract = contracts[0];

  return (
    <div className="animate-fade-in" data-testid="my-contract-page">
      <div className="mb-8">
        <h1 className="font-heading text-2xl sm:text-3xl font-medium text-[#1A1A1A] tracking-tight">Contract</h1>
        <p className="text-sm text-[#5C5C55] mt-1">Your licence agreement details</p>
      </div>

      {contract ? (
        <div className="bg-white rounded-2xl border border-[#E5E2DC] shadow-[0_2px_10px_rgba(0,0,0,0.02)] p-6 sm:p-8" data-testid="contract-details">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-12 h-12 rounded-2xl bg-[#E8EDE5] flex items-center justify-center">
              <FileText className="w-6 h-6 text-[#3A4035]" strokeWidth={1.5} />
            </div>
            <div>
              <h2 className="font-heading text-lg font-medium text-[#1A1A1A]">{contract.type}</h2>
              <span className={`text-xs px-3 py-1 rounded-full font-semibold capitalize ${contract.status === 'active' ? 'bg-[#E8EDE5] text-[#3A4035]' : 'bg-[#F4EFE6] text-[#7A6849]'}`}>
                {contract.status?.replace('_', ' ')}
              </span>
            </div>
          </div>

          <div className="space-y-4">
            <div className="flex items-center justify-between py-3 border-b border-[#F2F0EB]">
              <span className="text-sm text-[#5C5C55]">Monthly Rent</span>
              <span className="text-sm font-medium text-[#1A1A1A]">£{contract.monthly_rent?.toFixed(2)}</span>
            </div>
            <div className="flex items-center justify-between py-3 border-b border-[#F2F0EB]">
              <span className="text-sm text-[#5C5C55] flex items-center gap-2"><Calendar className="w-3.5 h-3.5" strokeWidth={1.5} />Start Date</span>
              <span className="text-sm font-medium text-[#1A1A1A]">{contract.start_date}</span>
            </div>
            <div className="flex items-center justify-between py-3 border-b border-[#F2F0EB]">
              <span className="text-sm text-[#5C5C55] flex items-center gap-2"><Clock className="w-3.5 h-3.5" strokeWidth={1.5} />End Date</span>
              <span className="text-sm font-medium text-[#1A1A1A]">{contract.end_date}</span>
            </div>
            {contract.signed_date && (
              <div className="flex items-center justify-between py-3">
                <span className="text-sm text-[#5C5C55]">Signed Date</span>
                <span className="text-sm font-medium text-[#1A1A1A]">{contract.signed_date}</span>
              </div>
            )}
          </div>
        </div>
      ) : (
        <div className="text-center py-16">
          <FileText className="w-10 h-10 text-[#D8DBD3] mx-auto mb-3" strokeWidth={1.5} />
          <p className="text-sm text-[#8A8B85]">No contract found</p>
        </div>
      )}
    </div>
  );
}
